module.exports = __webpack_public_path__ + "50e11e4075c62ce47c8b8bee13a9c05e.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsoft/assets/779.png
// module id = 1697
// module chunks = 2